import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const NotFoundStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  overflow: hidden;
  width: 300px;
  height: 220px;
`;

export const NotFoundTextContainer = styled(Box).attrs({
  mb: { sm: '700' },
})`
  position: absolute;
  bottom: 0;
`;

export const NavLink = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors.blue[600]};
    margin-top: ${theme.spacings[900]};
  `}
`;
